export const CUTOFF_DRAFT_GAMES = ['keno', 'mega', 'power', 'max3d', 'max3dpro', 'lotto535']
export const LOTO_SETTING_MANAGED_GAMES = ['loto', 'loto-mb', 'loto-mt', 'loto-mn', 'loto-thudo']

export const isGameEnabled = game =>
  game.id === 'lotto535' && typeof game.publicEnabled === 'boolean'
    ? game.publicEnabled
    : game.status === 1

// Display only the current legacy sources. Never infer active policy from a draft.
export function getGameCutoffSummary(game, kenoPrintSeconds) {
  if (game.cutoffPolicyEnabled === true) {
    const offset = seconds => Number.isSafeInteger(seconds) && seconds >= 0
      ? seconds % 60 === 0 ? `${seconds / 60} phút trước giờ xổ` : `${seconds} giây trước giờ xổ`
      : 'Cấu hình không hợp lệ'
    return {
      sale: { value: offset(game.saleCutoffOffsetSeconds), note: 'Áp dụng riêng cho từng kỳ' },
      print: { value: offset(game.printCutoffOffsetSeconds), note: 'Không cộng thêm dự phòng ngầm' },
      upload: { value: game.uploadCutoffMode === 'UNLIMITED' ? 'Không giới hạn' : offset(game.uploadCutoffOffsetSeconds),
        note: 'Độc lập với đóng in; giữ đúng kỳ đã in' },
    }
  }
  const { id, cutoffTime, printCutoffTime, cutoffOffsetSeconds, gameType } = game
  const perRegion = LOTO_SETTING_MANAGED_GAMES.includes(id)
  let sale = { value: cutoffTime ? `${cutoffTime} · giờ VN` : 'Theo giờ xổ từng kỳ', note: 'Giờ đóng mua đang cấu hình' }
  let print = { value: 'Không cấu hình tại đây', note: 'Không dùng mốc mua để mô tả upload' }
  if (id === 'keno') {
    sale = { value: `${cutoffOffsetSeconds ?? 30} giây trước giờ xổ`, note: cutoffOffsetSeconds == null ? 'Mặc định hiện hành: 30 giây' : 'Áp dụng theo mỗi kỳ' }
    print = kenoPrintSeconds == null
      ? { value: 'Chưa tải được cấu hình', note: 'Không tự suy ra từ giờ đóng mua' }
      : { value: `${kenoPrintSeconds} giây trước giờ xổ`, note: 'Cấu hình in Keno đang dùng' }
  } else if (id === 'lotto535') {
    sale = { value: 'Trong cấu hình Lotto 5/35', note: 'Áp dụng theo từng kỳ quay' }
    print = { value: 'Trong cấu hình Lotto 5/35', note: 'Mốc in riêng, không phải mốc upload' }
  } else if (perRegion) {
    sale = { value: 'Theo miền MB / MT / MN', note: 'Cấu hình chung trong Cài đặt Lô tô' }
  } else if (gameType === 'VIETLOTT') {
    print = {
      value: printCutoffTime ? `${printCutoffTime} · giờ VN` : cutoffTime ? `${cutoffTime} · giờ VN` : 'Theo giờ xổ từng kỳ',
      note: printCutoffTime ? 'Đã đặt mốc in riêng' : cutoffTime ? 'Chưa đặt riêng: đang dùng mốc mua' : 'Chưa đặt giờ in riêng',
    }
  }
  return {
    sale, print,
    upload: { value: 'Không giới hạn (cấu hình cũ)', note: 'Chưa áp dụng mốc upload riêng' },
  }
}
